import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { SUPPLIER_REQUEST_STATE } from '../constants';
import {
  zodCompanyRefSchema,
  zodPriorRejectionRefSchema,
  zodResolvedCompanyRefSchema,
  zodSubmittedSupplierInfoSchema,
} from '../validations';

/**
 * Zod schema for the GET /suppliers/requests query parameters.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_supplier_requests_suppliers_requests_get
 */
export const zodSupplierRequestsQueryParamsSchema = z.object({
  companyAccountId: z.uuid(),
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).prefault(0),
  searchString: z.string().trim().nullish(),
  state: z.array(z.enum(SUPPLIER_REQUEST_STATE)).nullish(),
});

/**
 * Zod schema for a single supplier request in the list (SupplierRequestListItem).
 */
export const zodSupplierRequestListItemSchema = z.object({
  createdAt: z.iso.datetime({ offset: true }),
  id: z.uuid(),
  potentialDuplicateCompanyId: z.uuid().nullish(),
  priorRejection: zodPriorRejectionRefSchema.nullish(),
  rejectionReason: z.string().nullish(),
  requestingCompany: zodCompanyRefSchema,
  requestingCompanyAccount: zodCompanyRefSchema,
  resolvedCompany: zodResolvedCompanyRefSchema.nullish(),
  state: z.enum(SUPPLIER_REQUEST_STATE),
  submitted: zodSubmittedSupplierInfoSchema,
});

/**
 * Zod schema for the paginated GET /suppliers/requests response (SupplierRequestListResponse).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_supplier_requests_suppliers_requests_get
 */
export const zodSupplierRequestsResponseSchema = z.object({
  data: z.array(zodSupplierRequestListItemSchema),
  hasNextPage: z.boolean(),
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().nonnegative().prefault(0),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative(),
});
